export default __webpack_public_path__ + "static/media/ren.b2614d27.png";